import { render, staticRenderFns } from "./permissions-header.vue?vue&type=template&id=73f26f60&scoped=true&"
var script = {}
import style0 from "./permissions-header.vue?vue&type=style&index=0&id=73f26f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f26f60",
  null
  
)

component.options.__file = "permissions-header.vue"
export default component.exports